import React, { useState, Fragment, useRef, useEffect } from "react";
import clss from "./MFregiApp.module.css";
import RefreshIcon from "@mui/icons-material/Refresh";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Box, Button, Paper, IconButton, Typography, Tabs, Tab, Menu, MenuItem, Chip, TextField, Select, FormControl, Dialog } from "@mui/material";
import { blue, green, orange, red, yellow, grey } from "@mui/material/colors";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PopoverBtns from "./StateChgPopover";
import Snackbar from "../../UI/Snackbar";
// import StatSync from "./StatSync"
import { createChatSocket } from "../../utils/chatSocket";
import QrCodeIcon from "@mui/icons-material/QrCode";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import QRreader from "./MFqrreader";
import Chatting from "../Contents/ChattingMobile";

// 외부 스크립트 불러오기
const script = document.createElement("script");
script.src = "w3.js";
// script.src = "https://www.w3schools.com/lib/w3.js"
script.async = true;
document.body.appendChild(script);

///////////// socket.io //////////////
const socket = createChatSocket();
///////////// socket.io //////////////

const ticon = {
  color: "white",
  fontSize: "2rem",
  marginTop: "0.5rem",
  marginRight: "0.5rem",
  marginLeft: "0rem",
  cursor: "pointer",
  backgroundColor: orange[500],
  borderRadius: "50%",
};

const fixedthead = {
  position: "sticky",
  top: 0,
  backgroundColor: green[500],
  color: "white",
  fontWeight: "bold",
  zIndex: 10,
};

const list = clss.list;

const RegiForm = (props) => {
  const location = useLocation();
  const qrs = location.search;
  const params = new URLSearchParams(qrs);
  sessionStorage.mfmid = params.get("id");

  ///////////// socket.io + CustomEvent //////////////
  const pendingStatusUpdateRef = useRef(null); // callRefreshList fetch가 stale 데이터로 덮어쓰는 것 방지
  const applyStatusUpdate = (snum, mfstatus) => {
    pendingStatusUpdateRef.current = { snum, mfstatus };
    setInputedMflist((prev) =>
      prev.map((item) =>
        String(item.snum) === String(snum) ? { ...item, mfstatus: String(mfstatus) } : item
      )
    );
  };
  useEffect(() => {
    const handler = (data) => {
      const { sort, dsid: recvDsid, snum, mfstatus } = data || {};
      console.log("[RegiForm] stsync 수신", { sort, dsid: recvDsid, snum, mfstatus });
      const myDsid = (sessionStorage.selectedDSid || "").trim();
      if (data.sort !== "stateChaged") return;
      if (data.dsid !== myDsid) {
        console.log("[RegiForm] stsync dsid 불일치로 무시 (수신 dsid:", recvDsid, ", 현재 selectedDSid:", myDsid, ")");
        return;
      }
      if (!data.snum || data.mfstatus == null) {
        console.log("[RegiForm stsync] snum 또는 mfstatus 누락:", data.snum, data.mfstatus);
        return;
      }
      console.log("[RegiForm] stsync 상태 반영 및 사인보드 갱신 요청", { snum, mfstatus });
      applyStatusUpdate(data.snum, data.mfstatus);
      // 동원자원앱과 동일: 사인보드 갱신 요청 (상태 변경 숫자 반영)
      if (typeof window.dispatchEvent === "function") {
        window.dispatchEvent(new CustomEvent("mfSignboardRefresh"));
        console.log("[RegiForm] mfSignboardRefresh 디스패치 완료");
      }
    };
    socket.on("stsync", handler);
    return () => socket.off("stsync", handler);
  }, []);
  useEffect(() => {
    const onStatusChanged = (e) => {
      const { dsid, snum, mfstatus } = e.detail || {};
      const myDsid = (sessionStorage.selectedDSid || "").trim();
      console.log("[RegiForm] mfStatusChanged 수신", { dsid, snum, mfstatus, myDsid });
      if (dsid !== myDsid || snum == null || mfstatus == null) return;
      console.log("[RegiForm] mfStatusChanged 반영 및 mfSignboardRefresh 디스패치");
      applyStatusUpdate(snum, mfstatus);
      // 동원자원앱과 동일: 사인보드 갱신 요청 (상태 변경 숫자 반영)
      if (typeof window.dispatchEvent === "function") {
        window.dispatchEvent(new CustomEvent("mfSignboardRefresh"));
      }
    };
    window.addEventListener("mfStatusChanged", onStatusChanged);
    return () => window.removeEventListener("mfStatusChanged", onStatusChanged);
  }, []);

  const [inputedMflist, setInputedMflist] = useState([]); // 활동중인 재난정보 리스트
  const [inputStatus, setInputStatus] = useState(true); // true : 등록, false : 수정
  const [rfshData, setRfshData] = useState(""); // 갱신요청 변수
  const [view, setView] = useState(false); // 메인화면 표시여부
  const [orglist, setOrglist] = useState([]); // 소속리스트
  const [orgoption, setOrgoption] = useState(); // 소속옵션리스트
  const [viewqr, setViewqr] = useState(false); // QR코드화면 표시여부
  const [viewtable, setViewtable] = useState(true); // 테이블 표시여부
  const [mfdata, setMfdata] = useState(null); // QR 스캐너에 전달할 데이터
  const [qrButtonClicked, setQrButtonClicked] = useState(false); // QR 버튼 클릭 여부
  const [tabValue, setTabValue] = useState(0); // 탭 상태 (0: 자원현황, 1: 자원등록, 2: 동원자원대화방)
  const [menuAnchor, setMenuAnchor] = useState(null); // 메뉴 앵커
  const [selectedRowId, setSelectedRowId] = useState(null); // 선택된 행 ID
  const [sortValue, setSortValue] = useState("선택"); // 자원종류 값
  const [orgValue, setOrgValue] = useState("선택"); // 소속 값
  const [qrModalOpen, setQrModalOpen] = useState(false); // QR 모달 열림 상태
  const [qrModalData, setQrModalData] = useState(null); // QR 모달에 전달할 데이터
  const [qrModalTitle, setQrModalTitle] = useState("QR 코드 스캐너"); // QR 모달 타이틀
  const [qrMode, setQrMode] = useState("stateOnly"); // "stateOnly" 상단=상태변경만, "registerOnly" 자원별=QR등록만
  const [qrMenuAnchor, setQrMenuAnchor] = useState(null); // QR 메뉴 앵커
  const [selectedQrSnum, setSelectedQrSnum] = useState(null); // 선택된 QR의 snum

  // QR 아이콘 스타일
  const qrIconStyle = {
    ...ticon,
    backgroundColor: qrButtonClicked ? green[500] : orange[500], // 클릭 여부에 따라 색상 변경
  };

  // QR 아이콘 클릭 핸들러
  const qrIconClickHandler = () => {
    setQrButtonClicked(false); // QR 아이콘 클릭 시 상태 초기화
  };

  // QR 종료 핸들러
  const handleQRClose = () => {
    setViewqr(false);
    setView(false);
    setViewtable(true);
    setQrButtonClicked(false);
  };

  // 상단 QR: 등록된 QR만 읽어서 상태변경만 가능 (QR 신규 등록 불가)
  const qrbtnHandlerforState = () => {
    sessionStorage.removeItem("snumforqrinput"); // 등록 대상 없음
    setQrModalData(null);
    setQrModalTitle("상태변경 QR 스캐너 (등록된 QR만 인식)");
    setQrModalOpen(true);
    setQrButtonClicked(false);
    setQrMode("stateOnly");
  };

  //차량용 QR 최초등록 (자원현황 탭용 - 모달)
  const qrbtnHandlerforRegistModal = (snum) => {
    console.log("QR Modal for snum:", snum);
    console.log("sessionStorage.mflist:", sessionStorage.mflist);

    try {
      // QR코드 기등록 여부 확인
      const mflists = JSON.parse(sessionStorage.mflist || "[]");
      const qrData = mflists.find(item => {
        const itemSnum = typeof item.snum === "string" ? item.snum : String(item.snum);
        const snumStr = typeof snum === "string" ? snum : String(snum);
        return itemSnum === snumStr && item.mfqcode;
      });

      if(qrData) {
        const confirmResult = window.confirm("이미 QR코드가 등록된 자원입니다. 수정하시겠습니까?");
        if (!confirmResult) {
          return;
        }
      }

      // 자원리스트에서 큐알 등록하는 자원정보 추출
      sessionStorage.snumforqrinput = snum;
      const mflist = JSON.parse(sessionStorage.mflist || "[]");
      console.log("mflist:", mflist);

      const data = mflist.find((item) => {
        const itemSnum = typeof item.snum === "string" ? item.snum : String(item.snum);
        const snumStr = typeof snum === "string" ? snum : String(snum);
        return itemSnum === snumStr;
      });
      
      console.log("Found data:", data);

      // qr등록대상 자원정보를 세션스토리지에 저장
      if (data) {
        sessionStorage.setItem("qrcontent", JSON.stringify(data));
      } else {
        // 데이터가 없어도 기본 정보로 모달 열기
        const defaultData = { snum: snum };
        sessionStorage.setItem("qrcontent", JSON.stringify(defaultData));
        sessionStorage.snumforqrinput = snum;
      }

      // 모달 열기 (해당 자원에 QR 등록만)
      setQrModalData(data || { snum: snum });
      setQrModalTitle("QR 코드 등록 (해당 자원에 등록)");
      setQrModalOpen(true);
      setQrButtonClicked(true);
      setQrMode("registerOnly");
      console.log("QR Modal opened, qrModalOpen:", true);
    } catch (error) {
      console.error("QR Modal error:", error);
      // 에러가 발생해도 모달은 열기
      sessionStorage.snumforqrinput = snum;
      setQrModalData({ snum: snum });
      setQrModalOpen(true);
      setQrButtonClicked(true);
      setQrMode("registerOnly");
    }
  }

  // QR 모달 닫기 핸들러
  const handleQRModalClose = () => {
    setQrModalOpen(false);
    setQrModalData(null);
    setQrButtonClicked(false);
    setQrMode("stateOnly");
  };

  // QR 등록 성공 콜백
  const handleQRRegistered = (updatedMflist) => {
    // sessionStorage.mflist를 업데이트된 리스트로 설정
    if (updatedMflist) {
      sessionStorage.setItem("mflist", JSON.stringify(updatedMflist));
      // inputedMflist 상태 업데이트하여 테이블 리렌더링
      setInputedMflist(updatedMflist);
    } else {
      // updatedMflist가 없으면 sessionStorage에서 다시 읽기
      const mflist = JSON.parse(sessionStorage.mflist || "[]");
      setInputedMflist(mflist);
    }
  };

  // 상태 변경 성공 콜백 (상태변경 QR 사용 시)
  const handleStateChanged = (updatedMflist) => {
    // sessionStorage.mflist를 업데이트된 리스트로 설정
    if (updatedMflist) {
      sessionStorage.setItem("mflist", JSON.stringify(updatedMflist));
      // inputedMflist 상태 업데이트하여 테이블 리렌더링
      setInputedMflist(updatedMflist);
    } else {
      // updatedMflist가 없으면 sessionStorage에서 다시 읽기
      const mflist = JSON.parse(sessionStorage.mflist || "[]");
      setInputedMflist(mflist);
    }
  };

  // QR 메뉴 닫기 핸들러
  const handleQRMenuClose = () => {
    setQrMenuAnchor(null);
    setSelectedQrSnum(null);
  };

  // QR 삭제 핸들러
  const handleQRDelete = async () => {
    if (!selectedQrSnum) return;

    const confirmResult = window.confirm("QR 코드를 삭제하시겠습니까?");
    if (!confirmResult) {
      handleQRMenuClose();
      return;
    }

    try {
      // QR 코드 삭제 API 호출 (qrcode를 빈 값으로 전송)
      const wstring = `${props.apiAddr}/get/inputqr?snum=${selectedQrSnum}&qrcode=`;
      console.log("QR 삭제 API 호출:", wstring);
      const response = await axios.get(wstring);
      const result = response.data.result;

      if (result == "success") {
        callSnakbar("QR 코드가 삭제되었습니다.", "success");
        
        // mflist에서 해당 snum을 가진 항목의 mfqcode를 null로 업데이트
        const mflist = JSON.parse(sessionStorage.mflist || "[]");
        const updatedMflist = mflist.map((item) => {
          const itemSnum = typeof item.snum === "string" ? item.snum : String(item.snum);
          const qrSnum = typeof selectedQrSnum === "string" ? selectedQrSnum : String(selectedQrSnum);
          
          if (itemSnum === qrSnum) {
            console.log("QR 코드 삭제:", item.snum);
            return { ...item, mfqcode: null };
          }
          return item;
        });
        sessionStorage.setItem("mflist", JSON.stringify(updatedMflist));
        
        // inputedMflist 상태 업데이트하여 테이블 리렌더링
        setInputedMflist(updatedMflist);
      } else {
        callSnakbar("QR 코드 삭제에 실패했습니다.", "error");
      }
    } catch (error) {
      console.error("QR 삭제 중 오류 발생:", error);
      callSnakbar("QR 코드 삭제 중 오류가 발생했습니다.", "error");
    }

    handleQRMenuClose();
  };

  const sendsync = (sort, org, eqp, isNew = false) => {
    try {
      let orgg = org && org !== "미입력" 
        ? org.replace(/본부|소방|안전|구조|재난|상|라|청|도|입력/g, "")
        : "";
      let eqpp = eqp && eqp !== "미입력" 
        ? eqp.replace("소방", "")
        : "";

      // 신규 등록 시 히스토리 텍스트 생성
      let transtxt = "";
      if (isNew && org && org !== "미입력" && sort && sort !== "선택" && sort !== "미입력" && sort !== "input") {
        // org에서 지역명만 추출 (예: "대전소방본부" → "대전")
        let regionName = org.replace(/소방|본부|안전|구조|재난|상|라|청|도|입력/g, "").trim();
        
        // 자원명 처리 (예: "소방지휘" → "소방지휘자원")
        let resourceName = sort;
        if (!resourceName.includes("자원")) {
          resourceName = resourceName + "자원";
        }
        
        transtxt = `${regionName} ${resourceName} 신규 등록`;
      }

      const param = {
        sort: sort,
        inputuser: sessionStorage.mfmid,
        dsid: sessionStorage.selectedDSid.trim(),
        org: orgg,
        eqp: eqpp,
        transtxt: transtxt,
        timestamp: new Date().toISOString(),
      };

      console.log("Sending sync:", param);
      socket.emit("stsync", param);
    } catch (error) {
      console.error("Status sync error:", error);
      callSnakbar("상태 동기화 중 오류가 발생했습니다", "error");
    }
  };
  ///////////// socket.io //////////////

  // const {snumRef, pnumRef, gradeRef, nameRef, orgRef, callsgnRef, sumnumRef} = useRef("");
  const sortRef = useRef("");
  const pnumRef = useRef("");
  const gradeRef = useRef("");
  const nameRef = useRef("");
  const orgRef = useRef("");
  const callsgnRef = useRef("");
  const sumnumRef = useRef("");
  const rcvnumRef = useRef(""); // 수신번호 ref 추가
  const editOriginalRef = useRef(null); // 수정 시 원본 값 (수정사항 없음 검사용)

  useEffect(() => {
    async function getInputedDsList() {
      const wstring = `${props.apiAddr}/get/mflist?id=${sessionStorage.mfmid}&dsid=${sessionStorage.selectedDSid}&_t=${Date.now()}`;
      console.log(wstring);
      const response = await axios.get(wstring);
      const responseData = response.data;
      console.log(responseData);

      // 데이터의 모든 문자열 값에서 공백 제거
      const trimmedData = responseData.map((item) => {
        const trimmedItem = {};
        Object.keys(item).forEach((key) => {
          if (typeof item[key] === "string") {
            trimmedItem[key] = item[key].trim();
          } else {
            trimmedItem[key] = item[key];
          }
        });
        return trimmedItem;
      });

      setOrglist(trimmedData);
      sessionStorage.mflist = JSON.stringify(trimmedData);
      oneORGgetlist(sessionStorage.nowlistkind);
    }
    getInputedDsList();
  }, [rfshData]);

  const editMfList = (e) => {
    const snum = e?.target?.parentNode?.parentNode?.id;
    if (!snum) return;
    const cnts = JSON.parse(sessionStorage.mflist || "[]");
    for (let i in cnts) {
      if (cnts[i].snum == snum) {
        sessionStorage.editsnum = cnts[i].snum;
        let sortVal = (cnts[i].mfeqp || "").trim();
        // 드롭다운 옵션은 "소방회복" 등 소방 접두사 사용. DB가 "회복"만 저장한 경우 매칭되도록 정규화
        if (sortVal && !sortVal.startsWith("소방") && !sortVal.includes("(인원)")) {
          const normalized = { 회복: "소방회복", 행정: "소방행정", 위성: "소방위성", 펌프: "소방펌프", 물탱크: "소방물탱크", 화학: "소방화학", 험지: "소방험지", 구조: "소방구조", 구급: "소방구급", 헬기: "소방헬기", 지휘: "소방지휘", 기타차량: "소방기타차량", 의소대: "소방의소대" };
          sortVal = normalized[sortVal] || "소방" + sortVal;
        }
        if (sortRef.current) { sortRef.current.value = sortVal; }
        setSortValue(sortVal);
        if (pnumRef.current) { pnumRef.current.value = cnts[i].mfphnum.trim(); }
        sessionStorage.edit_pnum = cnts[i].mfphnum.trim();
        if (gradeRef.current) { gradeRef.current.value = (cnts[i].mfgrd != null && cnts[i].mfgrd !== "undefined") ? String(cnts[i].mfgrd).replace(/ /gi, "") : ""; }
        if (nameRef.current) { nameRef.current.value = cnts[i].mfnm == null ? "" : cnts[i].mfnm.replace(/ /gi, ""); }
        const orgVal = cnts[i].mfdorg.trim();
        if (orgRef.current) { orgRef.current.value = orgVal; }
        setOrgValue(orgVal);
        if (callsgnRef.current) { callsgnRef.current.value = cnts[i].mfcsgn.trim(); }
        if (sumnumRef.current) { sumnumRef.current.value = cnts[i].mfsumnum.trim(); }
        const nm = (cnts[i].mfnm == null || cnts[i].mfnm === "미입력") ? "" : String(cnts[i].mfnm).replace(/ /gi, "");
        const gr = (cnts[i].mfgrd == null || cnts[i].mfgrd === "미입력" || cnts[i].mfgrd === "undefined") ? "" : String(cnts[i].mfgrd).replace(/ /gi, "");
        editOriginalRef.current = {
          sort: sortVal,
          pnum: (cnts[i].mfphnum || "").trim(),
          grade: gr,
          name: nm,
          org: orgVal,
          callsgn: (cnts[i].mfcsgn || "").trim(),
          sumnum: (cnts[i].mfsumnum || "").trim(),
        };
      }
    }
    setInputStatus(false);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    sessionStorage.removeItem("nowlistkind");
  }, []);

  const deleteMfList = (e) => {
    const sort = "delete";
    const parent = e?.target?.parentNode?.parentNode;
    const snum = parent?.id;
    if (!snum) return;

    let org = "";
    let eqp = "";
    const rowEl = parent?.children?.[3];
    if (rowEl?.textContent) {
      const tmp = rowEl.textContent;
      const parts = tmp.split("^");
      org = (parts[0] || "").trim();
      eqp = (parts[1] || "").trim();
    } else {
      const mflist = JSON.parse(sessionStorage.mflist || "[]");
      const row = mflist.find((item) => String(item.snum) === String(snum));
      if (row) {
        org = (row.mfdorg || "").trim();
        eqp = (row.mfeqp || "").trim();
      }
    }

    const delOX = window.confirm("삭제하시겠습니까?");
    if (!delOX) return;
    const delOX2 = window.confirm("정말 삭제하시겠습니까? 삭제된 데이터는 복구할 수 없습니다.");
    if (!delOX2) return;

    async function doDelete() {
      const wstring = `${props.apiAddr}/get/deletemflist?snum=${snum}`;
      console.log(wstring);
      const response = await axios.get(wstring);
      const result = response.data.result;
      if (result == "success") {
        callSnakbar("삭제되었습니다.", "success");
        sendsync(sort, org, eqp);
        setRfshData(Math.random());
      } else {
        callSnakbar("삭제에 실패했습니다.", "error");
      }
    }
    doDelete();
  };

  const callRefreshList = () => {
    setRfshData(Math.random());
  };

  useEffect(() => {
    const makeorglist = () => {
      const orgArr = [];
      for (let i in orglist) {
        let short = orglist[i].mfdorg
          .trim()
          .replace(/본부|소방|안전|구조|재난|상|라|청|도|입력/g, "");
        // mfdorg값을 배열상수 orgArr에다가 중복을 제외하고 f: str, s: short로 넣는데 처음 값은 f:"전체", s:"전체"로 넣는다
        if (orgArr.length == 0) {
          orgArr.push({ f: "", s: "전체" });
        }
        // 배열상수 orgArr에다가 중복을 제외하고 f: str, s: short로 넣는데 처음 값은 f:"전체", s:"전체"로 넣는다
        orgArr.push({ f: orglist[i].mfdorg.trim(), s: short });
        // 중복제거
        orgArr.map((item, index) => {
          for (let i = 0; i < index; i++) {
            if (item.f == orgArr[i].f) {
              orgArr.pop();
            }
          }
        });
      }
      console.log(orgArr);

      const oropt = orgArr.map((item) => (
        <option key={item.f} value={item.f}>
          {item.s}
        </option>
      ));
      setOrgoption(oropt);
    };
    makeorglist();
  }, [orglist]);

  const oneORGgetlist = async (e) => {
    // 기관별 동원자원 목록 가져오기
    console.log(e);
    let org;
    if (e == undefined) {
      // 첫번째 조회시 전체조회
      // org = sessionStorage.nowlistkind;
      org = "";
    } else if (e != "") {
      // e 가 텍스트인지 object 인지 구분
      if (typeof e == "object") {
        org = e.target.value;
      } else {
        org = e;
      }
    } else {
      org = "";
    }
    const dsid = sessionStorage.selectedDSid;
    let cnts = JSON.parse(sessionStorage.mflist || "[]");
    const pending = pendingStatusUpdateRef.current;
    if (pending) {
      cnts = cnts.map((item) =>
        String(item.snum) === String(pending.snum) ? { ...item, mfstatus: String(pending.mfstatus) } : item
      );
      sessionStorage.mflist = JSON.stringify(cnts);
      pendingStatusUpdateRef.current = null;
    }
    const filtered = org === "" ? cnts : cnts.filter((item) => item && item.mfdorg && item.mfdorg.trim() === org);
    console.log(filtered);
    setInputedMflist(filtered);
    org == ""
      ? (sessionStorage.nowlistkind = "")
      : (sessionStorage.nowlistkind = org);
  };

  //////////////  스낵바 호출 //////////////
  const [sbShow, setSbShow] = useState("");
  const callSnakbar = (msg, sort) => {
    // const msg = "삭제되었습니sdfsdfsd다.";
    // const sort = "warning" // info, success, warning, error
    setSbShow(+new Date() + "^" + msg + "^" + sort);
  };
  //////////////  스낵바 호출 //////////////

  const mflist = inputedMflist.map((item) => (
    //makeorglist(item.mfdorg),
    <tr id={item.snum} key={item.snum} className={list}>
      <td style={{ textAlign: "center", fontWeight: "500", fontSize: "0.95rem", padding: "8px 4px" }}>{item.seqnum}</td>
      <td style={{ textAlign: "center", fontSize: "0.95rem", padding: "8px 4px", whiteSpace: "nowrap" }}>
        {item.mfdorg
          .trim()
          .replace(/본부|소방|안전|구조|재난|상|라|청|도/g, "")}
      </td>
      <td style={{ textAlign: "center", fontSize: "0.95rem", padding: "8px 4px" }}>{item.mfcsgn.trim()}</td>
      <td style={{ display: "none" }}>{item.mfdorg + "^" + item.mfeqp}</td>
      <td style={{ textAlign: "center", padding: "8px 4px" }}>
        <PopoverBtns
          id={item.snum}
          name={item.mfnm}
          status={item.mfstatus}
          apiAddr={props.apiAddr}
          callRefreshList={callRefreshList}
          oneORGgetlist={oneORGgetlist}
          eqp={item.mfeqp}
          org={item.mfdorg}
          csgn={item.mfcsgn}
        />
      </td>
      <td style={{ textAlign: "center", padding: "8px 4px", whiteSpace: "nowrap" }}>
        <Box sx={{ display: "flex", gap: "4px", justifyContent: "center", flexWrap: "nowrap" }}>
          <Button
            variant="outlined"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              const fakeEvent = { target: { parentNode: { parentNode: { id: item.snum } } } };
              handleMenuOpen(e, item.snum);
            }}
            sx={{
              minWidth: "50px",
              padding: "8px 12px",
              backgroundColor: "#e8f5e9",
              borderColor: green[300],
              fontSize: "0.85rem",
              fontWeight: "600",
              borderRadius: "4px",
              height: "36px",
              whiteSpace: "nowrap",
            }}
          >
            수정
          </Button>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              if (item.mfqcode) {
                setSelectedQrSnum(item.snum);
                setQrMenuAnchor(e.currentTarget);
              } else {
                qrbtnHandlerforRegistModal(item.snum);
              }
            }}
            sx={{
              border: "1px solid",
              borderRadius: "4px",
              borderColor: item.mfqcode ? grey[300] : grey[400],
              color: item.mfqcode ? grey[500] : "inherit",
              backgroundColor: item.mfqcode ? grey[100] : "transparent",
              "&:hover": {
                borderColor: item.mfqcode ? grey[400] : grey[500],
                backgroundColor: item.mfqcode ? grey[200] : grey[50],
              },
            }}
            aria-label="QR"
          >
            <QrCodeIcon fontSize="small" />
          </IconButton>
        </Box>
      </td>
    </tr>
  ));

  const onSubminHandler = (event) => {
    event.preventDefault();

    // 필수 입력값 검증
    const farr = [];
    const etrdSort = sortRef.current.value != "선택";
    farr.push({ name: "자원종류", value: etrdSort, title: sortRef.current });
    const etrdPnum =
      pnumRef.current.value != "" && pnumRef.current.value.length == 13;
    farr.push({ name: "연락처", value: etrdPnum, title: pnumRef.current });
    const etrdCallsgn = callsgnRef.current.value != "";
    farr.push({
      name: "호출명",
      value: etrdCallsgn,
      title: callsgnRef.current,
    });
    const etrdSumnum = sumnumRef.current.value != "";
    farr.push({ name: "총인원", value: etrdSumnum, title: sumnumRef.current });

    for (let i in farr) {
      if (farr[i].value == false) {
        if (farr[i].name == "연락처") {
          alert("연락처를 정확히 입력해주세요.");
          farr[i].title.focus();
        } else {
          alert(`${farr[i].name}(을)를 입력해주세요.`);
          farr[i].title.focus();
        }
        return;
      }
    }

    const verifypnum = async () => {
      // 연락처 중복확인
      console.log("연락처 중복확인");
      const wstring = `${props.apiAddr}/get/verifypnum?id=${pnumRef.current.value}&dsid=${sessionStorage.selectedDSid}`;
      console.log(wstring);
      const response = await fetch(wstring);
      const responseData = await response.json();
      console.log(responseData.length);
      responseData.length === 0
        ? savetoDB()
        : alert("이미 등록된 연락처입니다.");
    };

    const savetoDB = async () => {
      const svsort = inputStatus ? "등록" : "수정";
      const saveOX = window.confirm(`${svsort}하시겠습니까?`);

      if (saveOX) {
        // 수정 모드: 변경사항이 없으면 에러 후 종료 (DB에 "미입력" 저장 방지)
        if (!inputStatus && editOriginalRef.current) {
          const v = (val) => (val == null || val === "미입력" ? "" : String(val).trim());
          const cur = {
            sort: (sortRef.current?.value || "").trim(),
            pnum: (pnumRef.current?.value || "").trim(),
            grade: v(gradeRef.current?.value),
            name: v(nameRef.current?.value),
            org: (orgRef.current?.value === "선택" ? "" : (orgRef.current?.value || "").trim()) || "",
            callsgn: (callsgnRef.current?.value || "").trim(),
            sumnum: (sumnumRef.current?.value || "").trim(),
          };
          const orig = editOriginalRef.current;
          if (
            cur.sort === orig.sort &&
            cur.pnum === orig.pnum &&
            cur.grade === orig.grade &&
            cur.name === orig.name &&
            cur.org === orig.org &&
            cur.callsgn === orig.callsgn &&
            cur.sumnum === orig.sumnum
          ) {
            callSnakbar("수정된 내용이 없습니다.", "error");
            return;
          }
        }

        setInputStatus("i");
        const wstring = `${props.apiAddr}/get/getsnum?dsid=${sessionStorage.selectedDSid}`;
        const response = await axios.get(wstring);
        const seqnum = Number(response.data[0].seqnum) + 1;

        const emptyOr = (val) => {
          const s = (val == null ? "" : String(val)).trim();
          return s === "" || s === "미입력" ? "" : s;
        };
        const regiData = {
          snum: sessionStorage.editsnum,
          datakind: inputStatus ? "new" : "edit",
          seqnum: seqnum,
          dsid: sessionStorage.selectedDSid.trim(),
          rgid: sessionStorage.mfmid,
          sort: sortRef.current.value,
          pnum: pnumRef.current.value,
          grade: emptyOr(gradeRef.current?.value),
          name: emptyOr(nameRef.current?.value),
          org: orgRef.current.value === "선택" ? "미입력" : orgRef.current.value,
          callsgn: callsgnRef.current.value,
          sumnum: sumnumRef.current.value,
          replyNumber: rcvnumRef.current.value || "0335800613",
          hqCode: localStorage.getItem("hq")?.trim() || "gw",
        };

        console.log(regiData);
        sendDataToDb(regiData);
      }
    };

    const initOredit = async () => {
      // 연락처 중복확인
      if (!inputStatus) {
        // 수정입력이면 전화번호 수정여부 확인후 수정이면 연락처 중복확인, 아니면 바로 저장
        const prepnum = sessionStorage.edit_pnum; // 수정전 전화번호
        const nowpnum = pnumRef.current.value; // 수정후 전화번호
        if (prepnum == nowpnum) {
          // 수정전 전화번호와 수정후 전화번호가 같으면 바로 저장
          console.log("전화번호외 다른부분 수정");
          savetoDB();
        } else {
          // 수정전 전화번호와 수정후 전화번호가 다르면 연락처 중복확인
          verifypnum();
        }
      } else {
        // 신규입력이면 연락처 중복확인
        verifypnum();
      }
    };
    initOredit();

    async function sendDataToDb(regiData) {
      // 동원력 DB입력
      const wstring = `${props.apiAddr}/post/mfinput`;
      console.log(wstring);
      const response = await axios.post(wstring, regiData);
      const result = response.data.result;
      console.log(result);
      if (result == "success") {
        inputStatus
          ? callSnakbar("등록되었습니다.", "success")
          : callSnakbar("수정되었습니다.", "success");
        initRef(); // 입력폼 초기화
        setRfshData(Math.random()); // 갱신요청 변수
        sendSms(regiData); // 문자발송
        setTimeout(() => {
          // 신규 등록일 때만 isNew를 true로 전달
          // sort: 자원종류, org: 기관, eqp: 장비(자원종류와 동일)
          sendsync(regiData.sort, regiData.org, regiData.sort, inputStatus);
        }, 100);
      } else {
        !inputStatus
          ? callSnakbar("수정에 실패했습니다.", "error")
          : callSnakbar("등록에 실패했습니다.", "error");
      }
    }
  };

  const sendSms = async (regiData) => {
    // 문자발송
    try {
      const wstring = `${props.apiAddr}/post/sendsms`;
      console.log(wstring);
      console.log(regiData);
      const response = await axios.post(wstring, regiData);
      const result = response.data.result;
      if (result == "success") {
        console.log("발송되었습니다.");
      } else {
        console.log("발송에 실패하였습니다.");
      }
    } catch (error) {
      // CORS 에러나 네트워크 에러 발생 시 에러를 무시하고 계속 진행
      // (자원 등록은 성공했으므로 문자 발송 실패해도 프로세스는 계속 진행)
      console.error("문자 발송 중 오류 발생:", error);
      if (error.code === "ERR_NETWORK" || error.message?.includes("CORS")) {
        console.warn("CORS 정책으로 인해 문자 발송이 차단되었습니다. 자원 등록은 정상적으로 완료되었습니다.");
      } else {
        console.warn("문자 발송에 실패했습니다. 자원 등록은 정상적으로 완료되었습니다.");
      }
    }
  };

  const initRef = () => {
    //  입력폼 초기화
    // ref가 null인지 확인하고 안전하게 처리
    if (sortRef.current) {
      sortRef.current.value = "선택";
    }
    setSortValue("선택");
    
    if (pnumRef.current) {
      pnumRef.current.value = "";
    }
    
    if (gradeRef.current) {
      gradeRef.current.value = "";
    }
    
    if (nameRef.current) {
      nameRef.current.value = "";
    }
    
    if (orgRef.current) {
      orgRef.current.value = "선택";
    }
    setOrgValue("선택");
    
    if (callsgnRef.current) {
      callsgnRef.current.value = "";
    }
    
    if (sumnumRef.current) {
      sumnumRef.current.value = "";
    }
    
    if (rcvnumRef.current) {
      rcvnumRef.current.value = "";
    }
    
    setInputStatus(true);
    
    // 자원현황 리스트 갱신
    setRfshData(Math.random());
  };

  const formatPhoneNumber = (e) => {
    // 전화번호 자동 하이픈
    let inputValue = e.target.value.replace(/\D/g, ""); // 숫자 이외의 문자 제거
    
    // 최대 11자리 숫자만 허용 (000-0000-0000 형식)
    if (inputValue.length > 11) {
      inputValue = inputValue.slice(0, 11);
    }
    
    //console.log(inputValue);
    if (inputValue.length > 0) {
      if (inputValue.length <= 3) {
        inputValue = inputValue;
      } else if (inputValue.length <= 7) {
        inputValue = inputValue.replace(/(\d{3})(\d+)/, "$1-$2");
      } else {
        inputValue = inputValue.replace(/(\d{3})(\d{4})(\d+)/, "$1-$2-$3");
      }
    }
    e.target.value = inputValue;
  };

  // 숫자만 입력 허용 핸들러
  const handlePhoneKeyPress = (e) => {
    // 숫자(0-9)와 백스페이스, 삭제, 탭, 화살표 키만 허용
    const char = String.fromCharCode(e.which || e.keyCode);
    if (!/[0-9]/.test(char) && !/[8,9,27,13,46,110,190]/.test(e.keyCode) && 
        !(e.keyCode >= 35 && e.keyCode <= 40) && !(e.keyCode === 65 && e.ctrlKey === true)) {
      e.preventDefault();
    }
  };

  const arrowbtnHandler = (e) => {
    // 화살표 버튼 클릭시 입력폼 표시여부
    console.log(e.target.id);
    const id = e.target.id;
    id == "up" ? setView(true) : setView(false);
  };

  const callsort = (e) => {
    // 전달받은 column번호 얻기
    const colnum = e.target.cellIndex + 1;
    const coltxt = `td:nth-child(${colnum})`;
    console.log(colnum);
    //eslint-disable-next-line
    w3.sortHTML("#regimflist", ".MFregiApp_list__uYYqc", coltxt);
  };

  // 메뉴 핸들러
  const handleMenuOpen = (event, rowId) => {
    setMenuAnchor(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setSelectedRowId(null);
  };

  const handleEditFromMenu = () => {
    if (selectedRowId) {
      const rowId = selectedRowId;
      handleMenuClose();
      setTabValue(1); // 자원현황 → 자원등록 탭으로 전환
      // 탭 전환 후 폼이 마운트된 다음에 값을 채움 (연락처·호출명·총인원 등 ref 기반 필드)
      setTimeout(() => {
        const fakeEvent = { target: { parentNode: { parentNode: { id: rowId } } } };
        editMfList(fakeEvent);
      }, 0);
    } else {
      handleMenuClose();
    }
  };

  const handleDeleteFromMenu = () => {
    if (selectedRowId) {
      const fakeEvent = { target: { parentNode: { parentNode: { id: selectedRowId } } } };
      deleteMfList(fakeEvent);
    }
    handleMenuClose();
  };

  // 스타일 정의
  const headerStyle = {
    backgroundColor: orange[500],
    color: "white",
    padding: "10px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  };

  const iconButtonStyle = {
    color: "white",
    backgroundColor: "rgba(255,255,255,0.2)",
    border: "1px solid rgba(255,255,255,0.5)",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.3)",
    },
  };

  const formContainerStyle = {
    backgroundColor: "#fafafa",
    padding: "10px 12px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  };

  const inputRowStyle = {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
    gap: "10px",
  };

  const labelStyle = {
    minWidth: "120px",
    fontWeight: "600",
    fontSize: "1.1rem",
    color: "#333",
    flexShrink: 0,
  };

  const requiredLabelStyle = {
    ...labelStyle,
    color: "#d32f2f",
  };

  const optionalLabelStyle = {
    ...labelStyle,
    color: "#1976d2",
  };

  const buttonStyle = {
    backgroundColor: orange[600],
    color: "white",
    padding: "12px 32px",
    fontSize: "1.2rem",
    fontWeight: "600",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    "&:hover": {
      backgroundColor: orange[700],
      boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
    },
  };

  return (
    <Fragment>
      <Snackbar sbShow={sbShow} />
      <Box sx={{ width: "100%", backgroundColor: "#f5f5f5" }}>
        {/* 헤더 */}
        <Paper elevation={3} sx={{ width: "100%" }}>
          <Box sx={headerStyle}>
            <IconButton
              onClick={props.refreshDSHandler}
              sx={iconButtonStyle}
            >
              <ArrowBackIcon sx={{ fontSize: "1.5rem" }} />
            </IconButton>
            <Box sx={{ textAlign: "center", flex: 1 }}>
              <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.5rem", lineHeight: 1.2 }}>
                동원자원 관리
              </Typography>
              <Typography variant="caption" sx={{ fontSize: "0.9rem", opacity: 0.9 }}>
                ({props.dstitle})
              </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: "8px" }}>
              <IconButton sx={iconButtonStyle} size="small" onClick={qrbtnHandlerforState}>
                <QrCodeIcon />
              </IconButton>
              <IconButton sx={iconButtonStyle} size="small" onClick={initRef}>
                <RefreshIcon />
              </IconButton>
            </Box>
          </Box>

          {/* 탭 네비게이션 */}
          <Box sx={{ borderBottom: 1, borderColor: "divider", backgroundColor: "#fff" }}>
            <Tabs
              value={tabValue}
              onChange={(e, newValue) => setTabValue(newValue)}
              sx={{
                "& .MuiTab-root": {
                  fontSize: "1.1rem",
                  fontWeight: "500",
                  minHeight: "44px",
                  textTransform: "none",
                  color: grey[600],
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: orange[50],
                    color: orange[700],
                  },
                },
                "& .Mui-selected": {
                  color: orange[600],
                  fontWeight: "700",
                  backgroundColor: orange[50],
                },
                "& .MuiTabs-indicator": {
                  height: "3px",
                  backgroundColor: orange[600],
                },
              }}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label="자원현황" />
              <Tab label="신규자원 등록" />
              {/* <Tab label="동원자원대화방" /> */}
            </Tabs>
          </Box>

          {/* 탭 내용: 0 자원현황, 1 자원등록, 2 동원자원대화방 */}
          {tabValue === 0 && (
            <Box sx={{ backgroundColor: "#fafafa", minHeight: "400px" }}>
              {viewtable && (
                <table id="regimflist" className={clss.table} style={{ width: "100%" }}>
                  <thead style={{ ...fixedthead, position: "sticky", top: 0, zIndex: 10 }}>
                    <tr>
                      <th id="id" onClick={callsort} style={{ width: "8%", minWidth: "36px", padding: "8px 4px", fontSize: "1rem", textAlign: "center" }}>
                        #
                      </th>
                      <th id="org" style={{ width: "7%", minWidth: "60px", padding: "8px 4px", fontSize: "1rem", textAlign: "center", whiteSpace: "nowrap", boxSizing: "border-box" }}>
                        <select
                          style={{ width: "100%", maxWidth: "100%", fontSize: "0.9rem", padding: "4px 16px 4px 6px", boxSizing: "border-box" }}
                          onChange={oneORGgetlist}
                        >
                          {orgoption}
                        </select>
                      </th>
                      <th id="name" onClick={callsort} style={{ width: "35%", padding: "8px 4px", fontSize: "1rem", textAlign: "center" }}>
                        장비명
                      </th>
                      <th id="eqp" style={{ display: "none" }}></th>
                      <th id="state" onClick={callsort} style={{ width: "18%", padding: "8px 4px", fontSize: "1rem", textAlign: "center" }}>
                        상태관리
                      </th>
                      <th id="mgr" onClick={callsort} style={{ width: "25%", minWidth: "120px", padding: "8px 4px", fontSize: "1rem", textAlign: "center" }}>
                        관리
                      </th>
                    </tr>
                  </thead>
                  <tbody>{mflist}</tbody>
                </table>
              )}
            </Box>
          )}

          {tabValue === 1 && (
            <Box sx={formContainerStyle}>
              {viewqr && (
                <div className={clss.qrcontainer}>
                  <QRreader
                    apiAddr={props.apiAddr}
                    mfdata={mfdata}
                    qrButtonClicked={qrButtonClicked}
                    onClose={handleQRClose}
                  />
                </div>
              )}

              {!view && (
                <>
                  {/* 필수 입력 필드 (빨간색 라벨) */}
                  <Box sx={inputRowStyle}>
                    <Typography sx={requiredLabelStyle}>자원종류 *</Typography>
                    <FormControl fullWidth>
                      <Select
                        value={sortValue}
                        onChange={(e) => {
                          setSortValue(e.target.value);
                          if (sortRef.current) {
                            sortRef.current.value = e.target.value;
                          }
                        }}
                        inputRef={sortRef}
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          fontSize: "1.1rem",
                          height: "40px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#d32f2f",
                            borderWidth: "2px",
                          },
                          "& .MuiSelect-select": {
                            padding: "8px 14px",
                          },
                        }}
                      >
                        <MenuItem value="선택">선택</MenuItem>
                        <MenuItem value="소방펌프">소방펌프</MenuItem>
                        <MenuItem value="소방물탱크">소방물탱크</MenuItem>
                        <MenuItem value="소방화학">소방화학</MenuItem>
                        <MenuItem value="소방험지">소방험지</MenuItem>
                        <MenuItem value="소방구조">소방구조</MenuItem>
                        <MenuItem value="소방구급">소방구급</MenuItem>
                        <MenuItem value="소방헬기">소방헬기</MenuItem>
                        <MenuItem value="소방지휘">소방지휘</MenuItem>
                        <MenuItem value="소방행정">소방행정</MenuItem>
                        <MenuItem value="소방회복">소방회복</MenuItem>
                        <MenuItem value="소방위성">소방위성</MenuItem>
                        <MenuItem value="소방기타차량">소방기타차량</MenuItem>
                        <MenuItem value="소방의소대">소방의소대</MenuItem>
                        <MenuItem value="경찰(인원)">경찰(인원)</MenuItem>
                        <MenuItem value="군(인원)">군(인원)</MenuItem>
                        <MenuItem value="공무원(인원)">공무원(인원)</MenuItem>
                        <MenuItem value="민간인(인원)">민간인(인원)</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>

                  <Box sx={inputRowStyle}>
                    <Typography sx={requiredLabelStyle}>연락처(대표) *</Typography>
                    <TextField
                      inputRef={pnumRef}
                      fullWidth
                      placeholder="010-1111-9999"
                      onChange={formatPhoneNumber}
                      onKeyPress={handlePhoneKeyPress}
                      inputProps={{
                        maxLength: 13,
                        inputMode: "numeric",
                        pattern: "[0-9-]*",
                      }}
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-root": {
                          fontSize: "1.1rem",
                          height: "40px",
                          "& input": {
                            padding: "8px 14px",
                          },
                          "& fieldset": {
                            borderColor: "#d32f2f",
                            borderWidth: "2px",
                          },
                        },
                      }}
                    />
                  </Box>

                  <Box sx={inputRowStyle}>
                    <Typography sx={requiredLabelStyle}>호출명(팀명) *</Typography>
                    <TextField
                      inputRef={callsgnRef}
                      fullWidth
                      placeholder="00펌프1, 1팀, 지원팀"
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-root": {
                          fontSize: "1.1rem",
                          height: "40px",
                          "& input": {
                            padding: "8px 14px",
                          },
                          "& fieldset": {
                            borderColor: "#d32f2f",
                            borderWidth: "2px",
                          },
                        },
                      }}
                    />
                  </Box>

                  <Box sx={inputRowStyle}>
                    <Typography sx={requiredLabelStyle}>총인원 *</Typography>
                    <TextField
                      inputRef={sumnumRef}
                      fullWidth
                      type="number"
                      placeholder="3"
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-root": {
                          fontSize: "1.1rem",
                          height: "40px",
                          "& input": {
                            padding: "8px 14px",
                          },
                          "& fieldset": {
                            borderColor: "#d32f2f",
                            borderWidth: "2px",
                          },
                        },
                      }}
                    />
                  </Box>

                  <Box sx={inputRowStyle}>
                    <Typography sx={requiredLabelStyle}>소속 *</Typography>
                    <FormControl fullWidth>
                      <Select
                        value={orgValue}
                        onChange={(e) => {
                          setOrgValue(e.target.value);
                          if (orgRef.current) {
                            orgRef.current.value = e.target.value;
                          }
                        }}
                        inputRef={orgRef}
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          fontSize: "1.1rem",
                          height: "40px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#d32f2f",
                            borderWidth: "2px",
                          },
                          "& .MuiSelect-select": {
                            padding: "8px 14px",
                          },
                        }}
                      >
                        <MenuItem value="선택">선택</MenuItem>
                        <MenuItem value="중앙구조본부">중앙구조본부</MenuItem>
                        <MenuItem value="서울소방재난본부">서울소방재난본부</MenuItem>
                        <MenuItem value="경기도소방본부">경기도소방본부</MenuItem>
                        <MenuItem value="경기북부소방본부">경기북부소방본부</MenuItem>
                        <MenuItem value="충청북도소방본부">충청북도소방본부</MenuItem>
                        <MenuItem value="경상북도소방본부">경상북도소방본부</MenuItem>
                        <MenuItem value="대구소방안전본부">대구소방안전본부</MenuItem>
                        <MenuItem value="대전소방본부">대전소방본부</MenuItem>
                        <MenuItem value="인천소방본부">인천소방본부</MenuItem>
                        <MenuItem value="강원도소방본부">강원도소방본부</MenuItem>
                        <MenuItem value="충청남도소방본부">충청남도소방본부</MenuItem>
                        <MenuItem value="전라북도소방본부">전라북도소방본부</MenuItem>
                        <MenuItem value="전라남도소방본부">전라남도소방본부</MenuItem>
                        <MenuItem value="경상남도소방본부">경상남도소방본부</MenuItem>
                        <MenuItem value="세종소방본부">세종소방본부</MenuItem>
                        <MenuItem value="광주소방본부">광주소방본부</MenuItem>
                        <MenuItem value="울산소방본부">울산소방본부</MenuItem>
                        <MenuItem value="부산소방본부">부산소방본부</MenuItem>
                        <MenuItem value="제주도소방본부">제주도소방본부</MenuItem>
                        <MenuItem value="기타입력">기타입력</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>

                  {/* 선택 입력 필드 (파란색 라벨) */}
                  <Box sx={inputRowStyle}>
                    <Typography sx={optionalLabelStyle}>직급</Typography>
                    <TextField
                      inputRef={gradeRef}
                      fullWidth
                      placeholder="소방위, 경위, 주사..."
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-root": {
                          fontSize: "1.1rem",
                          height: "40px",
                          "& input": {
                            padding: "8px 14px",
                          },
                          "& fieldset": {
                            borderColor: "#1976d2",
                            borderWidth: "2px",
                          },
                        },
                      }}
                    />
                  </Box>

                  <Box sx={inputRowStyle}>
                    <Typography sx={optionalLabelStyle}>이름</Typography>
                    <TextField
                      inputRef={nameRef}
                      fullWidth
                      placeholder="홍길동"
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-root": {
                          fontSize: "1.1rem",
                          height: "40px",
                          "& input": {
                            padding: "8px 14px",
                          },
                          "& fieldset": {
                            borderColor: "#1976d2",
                            borderWidth: "2px",
                          },
                        },
                      }}
                    />
                  </Box>

                  <Box sx={inputRowStyle}>
                    <Typography sx={optionalLabelStyle}>회신번호</Typography>
                    <TextField
                      inputRef={rcvnumRef}
                      fullWidth
                      placeholder="010-1111-9999"
                      onChange={formatPhoneNumber}
                      onKeyPress={handlePhoneKeyPress}
                      inputProps={{
                        maxLength: 13,
                        inputMode: "numeric",
                        pattern: "[0-9-]*",
                      }}
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-root": {
                          fontSize: "1.1rem",
                          height: "40px",
                          "& input": {
                            padding: "8px 14px",
                          },
                          "& fieldset": {
                            borderColor: "#1976d2",
                            borderWidth: "2px",
                          },
                        },
                      }}
                    />
                  </Box>

                  {/* 등록 버튼 */}
                  <Box sx={{ display: "flex", justifyContent: "center", marginTop: "12px" }}>
                    <Button
                      variant="contained"
                      onClick={onSubminHandler}
                      sx={buttonStyle}
                    >
                      {inputStatus ? "등 록" : "수 정"}
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          )}

          {tabValue === 2 && (
            <Box sx={{ minHeight: "400px", display: "flex", flexDirection: "column" }}>
              <Chatting apiAddr={props.apiAddr} />
            </Box>
          )}

          {/* 수정/삭제 메뉴 */}
          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <MenuItem
              onClick={handleEditFromMenu}
              sx={{
                fontSize: "0.95rem",
                padding: "8px 16px",
                "&:hover": {
                  backgroundColor: green[50],
                },
              }}
            >
              수정
            </MenuItem>
            <MenuItem
              onClick={handleDeleteFromMenu}
              sx={{
                fontSize: "0.95rem",
                padding: "8px 16px",
                color: "#d32f2f",
                "&:hover": {
                  backgroundColor: "#ffebee",
                },
              }}
            >
              삭제
            </MenuItem>
          </Menu>

          {/* QR 메뉴 */}
          <Menu
            anchorEl={qrMenuAnchor}
            open={Boolean(qrMenuAnchor)}
            onClose={handleQRMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <MenuItem
              onClick={() => {
                handleQRMenuClose();
                if (selectedQrSnum) {
                  qrbtnHandlerforRegistModal(selectedQrSnum);
                }
              }}
              sx={{
                fontSize: "0.95rem",
                padding: "8px 16px",
                "&:hover": {
                  backgroundColor: green[50],
                },
              }}
            >
              QR 수정
            </MenuItem>
            <MenuItem
              onClick={handleQRDelete}
              sx={{
                fontSize: "0.95rem",
                padding: "8px 16px",
                color: "#d32f2f",
                "&:hover": {
                  backgroundColor: "#ffebee",
                },
              }}
            >
              QR 삭제
            </MenuItem>
          </Menu>

        </Paper>

        {/* QR 스캐너 모달 (자원현황 탭용) - Paper 밖으로 이동 */}
        <Dialog
          open={qrModalOpen}
          onClose={handleQRModalClose}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "8px",
              maxHeight: "90vh",
            },
          }}
        >
          <Box sx={{ position: "relative" }}>
            <QRreader
              apiAddr={props.apiAddr}
              mfdata={qrModalData}
              qrButtonClicked={qrButtonClicked}
              qrMode={qrMode}
              onClose={handleQRModalClose}
              title={qrModalTitle}
              onQRRegistered={handleQRRegistered}
              onStateChanged={handleStateChanged}
            />
          </Box>
        </Dialog>
      </Box>
    </Fragment>
  );
};

export default RegiForm;
